import CheckIcon from '@mui/icons-material/Check';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLeft from '@mui/icons-material/KeyboardArrowLeft';
import ExpandRight from '@mui/icons-material/KeyboardArrowRight';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock';
import TourIcon from '@mui/icons-material/Tour';
import CircularProgress from '@mui/material/CircularProgress';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, matchPath } from 'react-router-dom';
import { getService } from './data/services';
import { getRoutePath } from './routes';
import UserContext from './UserContext';
import { withRouter, withRouterInnerRef } from './utils/withRouterRef';
import Confirmation from './components/feedback/Confirmation';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ProfileIcon from '@mui/icons-material/Storage';
import MenuItem from '@mui/material/MenuItem';
import { getProfileLabel } from './data/App';
import { NavigateBefore, PushPin } from '@mui/icons-material';
import { ListItemButton } from '@mui/material';
import { isSmall } from './utils/Device';

const styles = theme => ({
  toolbarSpacer: {
    ...theme.mixins.toolbar,
    height: '64px'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7)
  },
  drawerPaper: {
    justifyContent: 'space-between'
  },
  ossLicenses: {
    margin: theme.spacing(2)
  },
  ossLicensesButton: {
    color: '#aaa',
    fontWeight: 500
  }
});

const drawerWidth = 250;

class SideNavItem extends React.Component {

  static propTypes = {
    route: PropTypes.object,
    routes: PropTypes.array,
    router: PropTypes.object,
    hasVerifier: PropTypes.bool,
    location: PropTypes.object,
    openVerifier: PropTypes.func,
    navBar: PropTypes.object,
    openedDrawer: PropTypes.bool,
    previousRoute: PropTypes.object,
    nextRoute: PropTypes.object,
    menuOpenStatus: PropTypes.object,
    toggleGroup: PropTypes.func
  };

  static contextType = UserContext;

  constructor (props) {
    super(props);

    this.renderNavItem = this.renderNavItem.bind(this);
    this.showDefaultButtonInNavbar = this.showDefaultButtonInNavbar.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount () {
    const isOperator = this.context.user.groups.includes('Operator');
    const isSupport = this.context.user.groups.includes('Support');
    this.setState({ isOperator, isSupport });
  }

  showDefaultButtonInNavbar () {
    if (!this.props.navBar.current) {
      setTimeout(() => {
        this.showDefaultButtonInNavbar();
      }, 200);
    } else {
      this.props.navBar.current.showCloseButton(false);
      this.props.navBar.current.showBackButton(false);
    }
  }

  onKeyDown (event, route, previousRoute, nextRoute, routes) {
    const { menuOpenStatus } = this.props;
    if (event.code === 'Home') {
      if (routes && routes.length > 0) {
        const firstRoute = routes[0];
        const firstButton = document.getElementById(firstRoute.key + '_mainNav');
        if (firstButton) firstButton.focus();
      }
      event.preventDefault();
      event.stopPropagation();
    } else if (event.code === 'End') {
      if (routes && routes.length > 0) {
        const lastRoute = routes[routes.length - 1];
        const lastButton = document.getElementById(lastRoute.key + '_mainNav');
        if (lastButton) lastButton.focus();
      }
      event.preventDefault();
      event.stopPropagation();
    } else if (event.code === 'ArrowDown') {
      if (menuOpenStatus && menuOpenStatus[route.key]) {
        if (route.children?.length > 0) {
          const nextButton = document.getElementById(route.children[0].key + '_mainNav');
          if (nextButton) nextButton.focus();
        }
      } else if (nextRoute) {
        const nextButton = document.getElementById(nextRoute.key + '_mainNav');
        if (nextButton) nextButton.focus();
      }
      event.preventDefault();
      event.stopPropagation();
    } else if (event.code === 'ArrowUp') {
      if (previousRoute) {
        if (menuOpenStatus && menuOpenStatus[previousRoute.key] && previousRoute.children?.length > 0 && !previousRoute.children.find(child => child === route)) {
          const prevButton = document.getElementById(previousRoute.children[previousRoute.children.length - 1].key + '_mainNav');
          if (prevButton) prevButton.focus();
        } else {
          const prevButton = document.getElementById(previousRoute.key + '_mainNav');
          if (prevButton) prevButton.focus();
        }
      }
      event.preventDefault();
      event.stopPropagation();
    } else if (event.code === 'ArrowRight') {
      if (!menuOpenStatus || !menuOpenStatus[route.key]) {
        this.props.toggleGroup(route.key);
      }
      event.preventDefault();
      event.stopPropagation();
    } else if (event.code === 'ArrowLeft') {
      if (menuOpenStatus && menuOpenStatus[route.key]) {
        this.props.toggleGroup(route.key);
      }
      event.preventDefault();
      event.stopPropagation();
    }
  }

  renderNavItem (route, previousRoute, nextRoute, routes) {
    const { location, menuOpenStatus } = this.props;
    const isOperator = this.state?.isOperator;
    const isSupport = this.state?.isSupport;

    const routePath = getRoutePath(route.key) + '/*';
    const isMenu = !!route.children;
    const menuOpen = isMenu && menuOpenStatus[route.key];
    const isSelected = !!((!isMenu || !menuOpen) && matchPath(routePath, location.pathname));

    if (route.hidden) {
      return <span key={route.key}></span>;
    }

    if (route.path.startsWith('http')) {
      return <Tooltip key={`${route.key}-tooltip`} title={!this.props.openedDrawer ? <FormattedMessage id={route.text}/> : ''} placement="right"enterDelay={250}>
            <ListItem role='menuitem'>
              <ListItemButton key={route.key}
                id={route.key + '_mainNav'}
                aria-labelledby={route.key + '_mainNav_label'}
                tabIndex={-1}
                onKeyDown={(event) => this.onKeyDown(event, route, previousRoute, nextRoute, routes)}
                component={Link} to="/#" onClick={(event) => {
                  event.preventDefault();
                  window.open(route.path, route.key);
                }}>
                <ListItemIcon>{route.icon}</ListItemIcon>
                <ListItemText id={route.key + '_mainNav_label'} primary={<FormattedMessage id={route.text}/>}/>
              </ListItemButton>
            </ListItem>
          </Tooltip>;
    }

    return <Tooltip key={`${route.key}-tooltip`} title={!this.props.openedDrawer ? <FormattedMessage id={route.text} /> : ''} placement="right" enterDelay={250}>
      <ListItem role='menuitem'>
        <ListItemButton key={route.key}
          id={route.key + '_mainNav'}
          aria-labelledby={route.key + '_mainNav_label'}
          component={isMenu && route?.children?.length !== 0 ? null : Link}
          to={route.to}
          selected={isSelected}
          disableTouchRipple={isSelected}
          className={isSelected ? 'selected' : ''}
          tabIndex={isSelected ? 0 : -1} // route.key === 'home' ? 0 : -1
          onKeyDown={(event) => this.onKeyDown(event, route, previousRoute, nextRoute, routes)}
          onClick={event => {
            if (isMenu) {
              event.stopPropagation();
              this.props.toggleGroup(route.key);
              event.cancelBubble = true;
              return false;
            } else {
              if (isSelected) {
                event.stopPropagation();
                event.cancelBubble = true;
                return false;
              }
              if (!matchPath(route.path, this.props.location.pathname)) {
                this.showDefaultButtonInNavbar();
              }
            }
            return true;
          }}>
          <ListItemIcon>{route.icon}</ListItemIcon>
          <ListItemText id={route.key + '_mainNav_label'}>
            <FormattedMessage id={route.text} />
            {route.roles && route.roles.includes('Operator') &&
              <span className="operatorsOnly"><LockIcon /></span>
            }
            {(isOperator || isSupport) && route.featureFlags?.length > 0 &&
              <span className="operatorsOnly"><TourIcon /></span>
            }
          </ListItemText>
        </ListItemButton>
        {isMenu && <IconButton id={'openMenu' + route.key} aria-label={'openMenu' + route.key} tabIndex={-1} className='openMenu' onClick={() => this.props.toggleGroup(route.key)} size='small'>{menuOpen ? <ExpandLeft /> : <ExpandRight />}</IconButton>}
      </ListItem>
    </Tooltip>;
  }

  render () {
    if (!this.props) return (<div/>);
    const { route, previousRoute, nextRoute, routes } = this.props;

    // mind. 1 Abo mit Verbindungsdaten
    let anySubscriptionCompleted = false;
    if (route.key === 'verifier' && this.context.apps) {
      this.context.apps.forEach(appConfig => {
        const waitingForRegistration = !appConfig.apps || appConfig.apps.length === 0 || !!appConfig.apps.find(app => (!app.serviceName || (app.status && app.status === 'PROVISIONING')));
        anySubscriptionCompleted = anySubscriptionCompleted || !waitingForRegistration;
      });
    }
    const isExpandable = route.children && route.children.length > 0;

    if (route.key === 'verifier') {
      return <>
        {this.props.hasVerifier && anySubscriptionCompleted &&
          <ListItem role='menuitem'><Tooltip key={`${route.key}-tooltip`} title={!this.props.openedDrawer ? <FormattedMessage id={route.text}/> : ''} placement="right"
                   enterDelay={250}>
            <ListItemButton key={route.key}
              id={route.key + '_mainNav'}
              aria-labelledby={route.key + '_mainNav_label'}
              tabIndex={-1}
              onKeyDown={(event) => this.onKeyDown(event, route, previousRoute, nextRoute, routes)}
              component={Link} target="_blank" to="/#" onClick={(event) => {
                event.preventDefault();
                this.props.openVerifier();
              }}>
              <ListItemIcon>{route.icon}</ListItemIcon>
              <ListItemText id={route.key + '_mainNav_label'} primary={<FormattedMessage id={route.text}/>}/>
            </ListItemButton>
          </Tooltip></ListItem>}
      </>;
    } else if (route.path.startsWith('http')) {
      return <>
          <ListItem role='menuitem'><Tooltip key={`${route.key}-tooltip`} title={!this.props.openedDrawer ? <FormattedMessage id={route.text}/> : ''} placement="right"enterDelay={250}>
            <ListItemButton key={route.key} tabIndex={-1} component={Link} to="/#"
            id={route.key + '_mainNav'}
            aria-labelledby={route.key + '_mainNav_label'}
            onKeyDown={(event) => this.onKeyDown(event, route, previousRoute, nextRoute, routes)}
            onClick={(event) => {
              event.preventDefault();
              window.open(route.path, route.key);
            }}>
              <ListItemIcon>{route.icon}</ListItemIcon>
              <ListItemText primary={<FormattedMessage id={route.text}/>}/>
            </ListItemButton>
          </Tooltip></ListItem>
      </>;
    }

    const childRoutes = route.children?.filter(childRoute => !childRoute.hidden);
    const navItemRoot = this.renderNavItem(route, previousRoute, nextRoute, this.props.routes);

    const navItemChildren = isExpandable
      ? <Collapse component='li' in={this.props.menuOpenStatus[route.key]} timeout="auto" role="menuitem" unmountOnExit>
        <List component="ul" disablePadding role="menubar">
          {
              childRoutes
                .map((childRoute, index) => {
                  const isChildExpandable = childRoute.children && childRoute.children.length > 0;
                  const childPreviousRoute = index > 0 ? childRoutes[index - 1] : route;
                  const childNextRoute = index < childRoutes.length - 1 ? childRoutes[index + 1] : nextRoute;
                  if (isChildExpandable) {
                    return <SideNavItem key={index}
                          routes={childRoutes}
                          route={childRoute}
                          hasVerifier={this.props.hasVerifier}
                          openVerifier={this.openVerifierConfirmation}
                          location={this.props.location}
                          router={this.props.router}
                          navBar={this.props.navBar}
                          openedDrawer={this.props.openedDrawer}
                          previousRoute={childPreviousRoute}
                          nextRoute={childNextRoute}
                          menuOpenStatus={this.props.menuOpenStatus}
                          toggleGroup={this.props.toggleGroup}
                />;
                  } else {
                    // const hasChildActiveChild = isChildExpandable ? childRoute.children.map(child => matchPath(child.path, location.pathname)).reduce((prev, current) => prev || current) : false;
                    return this.renderNavItem(childRoute, childPreviousRoute, childNextRoute, childRoutes);
                  }
                })
          }
        </List>
      </Collapse>
      : null;

    return (
      <>
        {navItemRoot}
        {navItemChildren}
      </>
    );
  }

}

// eslint-disable-next-line no-class-assign
SideNavItem = withRouter(SideNavItem);

class SideNav extends React.Component {

  static propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    drawer: PropTypes.object,
    router: PropTypes.object,
    hasVerifier: PropTypes.bool,
    routes: PropTypes.array,
    onToggle: PropTypes.func,
    onTypeChange: PropTypes.func,
    navigate: PropTypes.func,
    intl: PropTypes.object,
    user: PropTypes.object,
    navBar: PropTypes.object,
    location: PropTypes.object
  };

  static contextType = UserContext;

  constructor (props) {
    super(props);
    this.state = {
      open: true,
      openBsPopover: false,
      disableToggle: false,
      routes: [],
      pollForServicesAndProfiles: false,
      pollForServicesAndProfilesCompleted: false,
      showOpenVerifierConfirmation: false,
      visibleVerifierProfiles: [],
      menuOpenStatus: this.updateMenuOpenStatus(props.routes, props.location.pathname),
      tempOpen: false
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.openVerifierConfirmation = this.openVerifierConfirmation.bind(this);
    this.openVerifier = this.openVerifier.bind(this);
    this.loginVerifier = this.loginVerifier.bind(this);
    this.changeOpenState = this.changeOpenState.bind(this);
    this.openBsMenu = this.openBsMenu.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
    this.loadVisibleVerifierProfiles = this.loadVisibleVerifierProfiles.bind(this);
    this.toggleGroup = this.toggleGroup.bind(this);
  }

  updateMenuOpenStatus (routes, currentPath) {
    const openChildren = {};
    routes?.forEach(route => {
      openChildren[route.key] = !!currentPath.startsWith(route.to) && !!route.children;
      if (route.children?.length > 0) {
        const openSubchildren = this.updateMenuOpenStatus(route.children, currentPath);
        if (openSubchildren) { Object.assign(openChildren, openSubchildren); }
      }
    });
    return openChildren;
  }

  toggleGroup (key) {
    const menuOpenStatus = Object.assign({}, this.state.menuOpenStatus);
    menuOpenStatus[key] = !menuOpenStatus[key];
    this.setState({ menuOpenStatus });
  }

  toggleDrawer (manual = true) {
    if (!this.state.disableToggle) {
      this.setState({ open: !this.state.open, disableToggle: true }, () => {
        if (this.props.onToggle) {
          this.props.onToggle(this.state.open);
        }
        if (manual) {
          localStorage.setItem('sideNav.open', this.state.open);
        }
        setTimeout(() => this.setState({ disableToggle: false }), 200);
      });
    }
  }

  closeDrawer (manual = true) {
    if (this.state.open) this.toggleDrawer(manual);
  }

  openDrawer (manual = true) {
    if (!this.state.open) this.toggleDrawer(manual);
  }

  restoreDrawer () {
    const open = localStorage.getItem('sideNav.open') || true;
    if (open) this.openDrawer(false); else this.closeDrawer(false);
  }

  changeOpenState (open) {
    if (!this.state.disableToggle) {
      this.setState({ open, disableToggle: true }, () => setTimeout(() => this.setState({ disableToggle: false }), 200));
      if (this.props.onToggle) {
        this.props.onToggle(open);
      }
    }
  }

  componentDidMount () {
    const tenant = this.context.user.signInUserSession.idToken.payload.logon.toUpperCase();
    const profileName = localStorage.getItem(tenant + '.defaultVerifierProfile') || this.context?.selectedProfile?.name;
    this.setState({ profileName });
    window.addEventListener('message', (event) => {
      if (event.data === 'Listening for token') {
        console.log('Listening for token');
        this.loginVerifier(100);
      } else if (event.data === 'No token received') {
        console.log('No token received');
        this.loginVerifier(1000);
      } else if (event.data === 'Credentials received') {
        console.log('Credentials received');
        this.setState({ waitForVerifierInit: false });
      }
    }, false);
    this.loadVisibleVerifierProfiles();
  }

  componentDidUpdate (prevProps) {
    if (this.props.open !== undefined && this.state.open !== this.props.open && !this.state.disableToggle) {
      this.setState({ open: this.props.open });
    }
    if (this.props?.user !== prevProps?.user) {
      this.loadVisibleVerifierProfiles();
    }
  }

  loadVisibleVerifierProfiles () {
    const visibleVerifierProfilesUnsorted = [...new Set(this.context.user.allRoles?.filter(role => role.includes(':Verifier'))?.map(role => role.split(':')[0]))];
    const visibleVerifierProfiles = this.context.visibleApps?.filter(app => visibleVerifierProfilesUnsorted?.includes(app.profileName));
    if (visibleVerifierProfiles) {
      this.setState({
        visibleVerifierProfiles
      });
    }
  }

  handleProfileChange = (event, value) => {
    const newValue = value && value.props ? value.props.value : value;
    const appConfigs = this.context.apps;
    const newIndex = appConfigs.findIndex(config => config.profileName === newValue);
    const tenant = this.context.user.signInUserSession.idToken.payload.logon.toUpperCase();
    localStorage.setItem(tenant + '.defaultVerifierProfile', newValue);
    this.setState({
      profileName: newValue,
      profileIndex: newIndex
    });
  };

  openVerifierConfirmation () {
    if (this.state.visibleVerifierProfiles?.length > 1) {
      this.setState({ showOpenVerifierConfirmation: true });
    } else {
      this.openVerifier();
    }
  }

  openVerifier () {
    const profile = this.state.visibleVerifierProfiles?.length === 1
      ? this.state.visibleVerifierProfiles[0].profileName
      : (this.state.profileName || (this.context.selectedProfile ? this.context.selectedProfile.name : this.context.selectedProfile));
    if (profile) {
      try {
        // TODO : Das profil ist teils alt. Bei einer Neu-Anmeldung teils sogar nicht gesetzt
        const appConfig = this.context.apps.find(app => app.profileName === profile);
        let dvService = appConfig.services.find(service => service.name === 'DV');
        dvService = (dvService) || getService('DV');
        const baseUrl = dvService.appBaseUrl;
        // baseUrl = 'http://localhost';
        const tenant = this.context.user.signInUserSession.idToken.payload.logon.toUpperCase() + '_' + profile.toUpperCase();
        const verifierWindow = window.open(new URL(`/isrinformationoffice/web/index.html?tenant=${tenant}&useToken=true`, baseUrl).href, 'verifier');
        console.log('Opened verifier in extra window');
        this.setState({ verifierWindow, baseUrl, waitForVerifierInit: true });
      } catch (e) {
        console.log('profile', profile, this.state.profileName);
        console.error(e);
        // Could not open DV with given profile, show confirmation dialog
        this.setState({ showOpenVerifierConfirmation: true });
      }
    } else {
      console.log('No profile selected. Can not open DV');
    }
  }

  loginVerifier (delay) {
    if (this.state.verifierWindow && this.state.waitForVerifierInit) {
      this.context.user.getCachedDeviceKeyAndPassword();
      const accessToken = this.context.user.signInUserSession.accessToken.jwtToken;
      const idToken = this.context.user.signInUserSession.idToken.jwtToken;
      const refreshToken = this.context.user.signInUserSession.refreshToken.token;
      const deviceKey = this.context.user.deviceKey;
      const deviceGroupKey = this.context.user.deviceGroupKey;
      const randomPassword = this.context.user.randomPassword;
      const ssoAppClientId = localStorage.getItem('tenant-appClient');
      const message = JSON.stringify({ accessToken, idToken, refreshToken, deviceKey, deviceGroupKey, randomPassword, ssoAppClientId });
      console.log('VerifierWindow', !!this.state.verifierWindow);

      setTimeout(() => {
        try {
          const result = this.state.verifierWindow.postMessage(message, `${this.state.baseUrl}/isrinformationoffice/`);
          console.log(result);
        } catch (error) {
          console.error('Failed sending Message', error);
        }
      }, delay);
    }
  }

  async waitForAppConfig (waitingTime, callback) {
    this.setState({ pollForServicesAndProfiles: true });
    await this.context.loadApps();
    if (this.context.apps) {
      let doPoll = false;
      this.context.apps.forEach(appConfig => {
        const waitingForRegistration = !appConfig.apps || appConfig.apps.length === 0 || appConfig.apps.find(app => (!app.serviceName || (app.status && app.status === 'PROVISIONING')));
        doPoll = doPoll || !!waitingForRegistration;
      });
      /** Warte max 5 min */
      if (doPoll && (waitingTime === undefined || waitingTime < 300000)) {
        setTimeout(() => this.waitForAppConfig(waitingTime ? (waitingTime + 2000) : 2000, callback), 2000);
      } else if (!doPoll && waitingTime > 0) {
        this.setState({ pollForServicesAndProfilesCompleted: true });
        setTimeout(() => this.setState({ pollForServicesAndProfiles: false, pollForServicesAndProfilesCompleted: false }), 10000);
        if (callback) await callback();
        this.context.loadApps();
      } else if (!doPoll) {
        this.setState({ pollForServicesAndProfilesCompleted: true });
        setTimeout(() => this.setState({ pollForServicesAndProfiles: false, pollForServicesAndProfilesCompleted: false }), 10000);
        console.error('no app found');
      }
    }
  };

  navigateToAbout = () => {
    const { navigate } = this.props;
    navigate('/about');
  };

  openBsMenu (event) {
    this.setState({ openBsPopover: true, bsMenuAnchor: event.currentTarget });
  }

  render () {
    const { classes } = this.props;
    const hasAbo = this.context.apps.find(app => app.apps && app.apps.length > 0);
    const stateCls = this.state.open ? 'drawer_open' : 'drawer_closed';
    const filteredRoutes = this.props.routes.filter(route => !route.hidePerDefault && !route.hidden);
    const drawer = <div className={stateCls}>
      <div className={classes.toolbarSpacer}>
        <div className="logoWrapper">
          <img id="companyLogo" src='/Buildsimple_Logo_dunkelblau.svg' alt=""/>
          <IconButton id='aboutBuildsimpleMenu' aria-label='About Buildsimple Menu' tabIndex={-1} size='small' onClick={this.openBsMenu}>{this.state.openBsPopover ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </div>

      </div>
      <Divider />
      <List role='menubar'>
        {filteredRoutes
          .map((route, index) =>
          <SideNavItem key={index}
                       routes={filteredRoutes}
                       route={route}
                       hasVerifier={this.props.hasVerifier}
                       openVerifier={this.openVerifierConfirmation}
                       navBar={this.props.navBar}
                       openedDrawer={!!this.state.open}
                       previousRoute={index > 0 ? filteredRoutes[index - 1] : undefined}
                       nextRoute={index < filteredRoutes.length - 1 ? filteredRoutes[index + 1] : undefined}
                       menuOpenStatus={this.state.menuOpenStatus}
                       toggleGroup={this.toggleGroup}
          />
          )}
      </List>
      {this.state.tempOpen
        ? <IconButton
        id="toggleSideNav"
        aria-label={this.props.intl?.formatMessage({ id: this.state.open ? 'sideNav.hide' : 'sideNav.show' })}
        onClick={() => { this.closeOnMouseOut = false; this.setState({ tempOpen: false }); }} className='smallToggle' size='small'>
        <PushPin />
      </IconButton>
        : <IconButton
        id="toggleSideNav"
        aria-label={this.props.intl?.formatMessage({ id: this.state.open ? 'sideNav.hide' : 'sideNav.show' })}
        onClick={this.toggleDrawer} className='smallToggle' size='small'>
        <NavigateBefore />
      </IconButton>
      }
      {this.state.pollForServicesAndProfiles &&
        <div className="pollingStatus">
          <div className="circularProgressWrapper">
            {!this.state.pollForServicesAndProfilesCompleted &&
              <CircularProgress />
            }
            <CheckIcon className={this.state.pollForServicesAndProfilesCompleted ? 'completed show' : 'completed'}/>
          </div>
          <div className="message" id='pollServiceStatusMessage'>
            <FormattedMessage id={'service.pollForServicesAndProfiles' + (this.state.pollForServicesAndProfilesCompleted ? '.success' : '')} />
          </div>
        </div>
      }
    </div>;

    return <>

      <Popover
        id='bsPopover'
        open={this.state.openBsPopover}
        onClose={() => this.setState({ openBsPopover: false })}
        anchorEl={this.state.bsMenuAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >

        <List component="nav">
          <ListItem>
            <ListItemButton
              onClick={() => { this.setState({ openBsPopover: false }); this.navigateToAbout(); }}
            >
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText>
                <FormattedMessage id='about.title' />
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>

      </Popover>

      <Confirmation
        id="openVerifierConfirmation"
        title={<FormattedMessage id="service.label.dv" />}
        open={this.state.showOpenVerifierConfirmation}
        onClose={() => this.setState({ showOpenVerifierConfirmation: false })}
        onConfirmation={this.openVerifier}
        message={<>
            {this.state.visibleVerifierProfiles && this.state.visibleVerifierProfiles.length > 1 &&
              <TextField
                select
                id="profileName"
                name="profileName"
                value={this.state.profileName}
                onChange={this.handleProfileChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ProfileIcon />
                    </InputAdornment>
                  )
                }}
                SelectProps={{
                  native: false,
                  multiple: false
                }}
                style={{ minWidth: '200px', marginTop: '4px', marginBottom: '2rem' }}
                size="small"
                variant="outlined"
                spellCheck="false"
                className="profile"
              >
                {this.state.visibleVerifierProfiles.map((appConfig, idx) => {
                  const waitingForRegistration = hasAbo && (!appConfig.apps || appConfig.apps.length === 0 || !!appConfig.apps.find(app => (!app.serviceName || (app.serviceName === 'DV' && app.status && app.status === 'PROVISIONING'))));
                  if (!waitingForRegistration) {
                    return (
                      <MenuItem key={idx} value={appConfig.profileName}>{getProfileLabel(appConfig)}</MenuItem>
                    );
                  }
                  return (<></>);
                })}
              </TextField>
            }
        </>}
        okButtonText={<FormattedMessage id='open'/>}
        okButtonProps={{ variant: 'contained', endIcon: <OpenInNewIcon /> }}
      />

      {isSmall()
        ? <nav aria-label={this.props.intl.formatMessage({ id: 'aria.sideNav' })}>
          <Drawer
            variant="temporary"
            className={classes.drawer + ' light'}
            classes={{
              paper: classes.drawerPaper
            }}
            open={this.state.open}
            onClose={() => this.changeOpenState(false)}
            onLoad={() => {
              this.props.onTypeChange(false);
            }}
          >
            {drawer}
          </Drawer>
        </nav>

        : <nav aria-label={this.props.intl.formatMessage({ id: 'aria.sideNav' })}>
          <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
              [classes.drawerOpen]: this.state.open,
              [classes.drawerClose]: !this.state.open
            }) + ' light'}
            classes={{
              paper: clsx({
                [classes.drawerOpen]: this.state.open,
                [classes.drawerClose]: !this.state.open
              }, classes.drawerPaper)
            }}
            open={this.state.open}
            onLoad={() => {
              this.props.onTypeChange(true);
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      }

    </>;
  }

}

export default withStyles(styles)(withRouterInnerRef(SideNav));
